// FoodLens 실패 코드 → 사용자 안내 분류.
//
// 코드값 원본은 android .../foodlens/FoodLensModule.kt 의 errorCode() 이며,
// SDK 의 BaseError 서브클래스(QuotaLimitExceedError / InvalidTokenError / NetworkError 등)를
// 그대로 문자열로 바꾼 것이다. 브릿지가 payload.code 로 전달한다.
//
// 분류 목적: "다시 촬영하면 되는 실패"와 "다시 촬영해도 안 되는 실패"를 갈라서
// 후자에 "다시 촬영해 주세요" 를 띄우지 않는 것.

// 사용자가 재촬영으로 해결 가능 — 사진 문제
const RETAKE = [
    'EMPTY_RESULT',          // 웹 판정: 정상 응답인데 foods 0개 (그릇이 프레임에 잘림 등)
    'IMAGE_DECODING_ERROR',
    'IMAGE_PROCESS_ERROR',
    'FILE_NOT_FOUND',
    'NORMALIZE_ERROR',
];

// 일시적 — 연결/서버 문제. 잠시 후 재시도하면 될 수 있음
//
// ⚠ SERVER_NOT_WORKING 을 "두잉랩 서버 장애"로만 보면 안 된다.
// 2026-07-30 실기기 확인: 비행기모드(=단말 네트워크 끊김)에서도 SDK 가
// NetworkError 가 아니라 ServerNotWokError 를 던진다.
//   predict onError code=SERVER_NOT_WORKING type=ServerNotWokError
//   message=Unable to resolve host "api.foodlens.ai": No address associated with hostname
// DNS 조회 실패를 SDK 가 서버 장애로 분류하는 것으로 보인다.
// → 이 코드를 개발자 알림 대상으로 잡으면 통신 안 되는 사용자마다 알림이 쏟아진다.
//   반드시 network(사용자 안내) 버킷에 남겨둘 것.
// NETWORK_ERROR 가 실제로 발생하는 경로는 아직 확인되지 않았다.
const NETWORK = [
    'NETWORK_ERROR',
    'SERVER_NOT_WORKING',
    'INVALID_SERVER_RESPONSE',
    'TIMEOUT',               // 웹 판정: 30초 무응답
];

// 사용자가 뭘 해도 안 됨 — 토큰/계약/앱등록 문제. 개발자가 조치해야 한다
const BLOCKED = [
    'QUOTA_EXCEEDED',        // 호출 계약 횟수 초과
    'INVALID_TOKEN',
    'INVALID_APPLICATION',
    'SETTING_ERROR',
    'BAD_REQUEST',
];

const MESSAGES = {
    retake: {
        title: '음식 인식 실패',
        desc: '음식을 발견하지 못했어요.\n식사를 다시 기록해 주세요.',
    },
    network: {
        title: '연결에 실패했어요',
        desc: '네트워크 상태를 확인한 뒤\n잠시 후 다시 시도해 주세요.',
    },
    blocked: {
        title: '일시적인 오류예요',
        desc: '잠시 후 다시 시도해 주세요.\n문제가 계속되면 문의해 주세요.',
    },
};

/**
 * @param  {string} code  브릿지가 준 payload.code (없으면 'UNKNOWN_ERROR')
 * @return {{ kind: 'retake'|'network'|'blocked', title: string, desc: string, retryable: boolean, code: string }}
 *
 * 모르는 코드는 기존 동작 유지를 위해 retake 로 떨어뜨린다.
 */
export const classifyFoodLensError = (code) => {
    const c = code || 'UNKNOWN_ERROR';
    const kind = BLOCKED.includes(c) ? 'blocked'
        : NETWORK.includes(c) ? 'network'
            : RETAKE.includes(c) ? 'retake'
                : 'retake';
    return {
        kind,
        ...MESSAGES[kind],
        // blocked 는 사용자가 재촬영해도 동일하게 실패한다
        retryable: kind !== 'blocked',
        code: c,
    };
};

/** 개발자가 조치해야 하는 실패인지 — 서버 에러 로그 전송 대상 판별용 */
export const isDeveloperFault = (code) => BLOCKED.includes(code || '');
